import { FaBed, FaUserFriends } from "react-icons/fa";
import { AiTwotoneCalendar } from "react-icons/ai";
import { MdOutlineArrowDropDown } from "react-icons/md";
import { format, addDays } from "date-fns";
import { useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./booking-bar.css";

export const BookingBar = () => {
  const [dateState, setDateState] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 1),
      key: "selection",
    },
  ]);

  const [typeState, setTypeState] = useState("Select Room Type");

  const [openOptions, setOpenOptions] = useState(false);
  const [options, setOptions] = useState({
    adult: 1,
    room: 1,
  });

  const [openDropdown, setOpenDropdown] = useState(false);
  const [openDate, setOpenDate] = useState(false);

  const handleOption = (name, operation) => {
    setOptions((prev) => {
      return {
        ...prev,
        [name]: operation === "i" ? options[name] + 1 : options[name] - 1,
      };
    });
  };

  function convertDateFormat(dateString) {
    // Split the date string into three parts.
    console.log(dateString);
    const [day, month, year] = dateString.split("/");

    // Rearrange the parts in the order of year, month, and day.
    const convertedDateString = `${year}-${month}-${day}`;

    // Return the converted date string.
    return convertedDateString;
  }

  function convertRoomTypeFormat(type) {
    const [first, second] = type.split(" ");

    const convertedType = `${first}+${second}`;

    console.log(convertedType);

    return convertedType;
  }

  const handleSubmit = (event) => {
    const url = `https://docs.google.com/forms/d/e/1FAIpQLSeODAN5kmIEDo-z5xZgfYnk_GD5nnGwqcauKe042J1jygasqg/viewform?usp=pp_url&entry.1980350274=${
      options.adult
    }&entry.1534861217=${convertDateFormat(
      format(dateState[0].endDate, "dd/MM/yyyy")
    )}&entry.2080276382=${convertDateFormat(
      format(dateState[0].startDate, "dd/MM/yyyy")
    )}&entry.361077647=${convertRoomTypeFormat(typeState)}&entry.1219068314=${
      options.room
    }`;
    window.open(url, "_blank");
    console.log("here");
  };
  return (
    <form
      className=" md:h-[93px] relative bg-white md:flex md:items-center md:absolute md:bottom-[-45px] md:max-w-[1210px] w-full md:left-1/2 md:transform md:-translate-x-1/2 border-[#dedede] md:shadow-lg z-[2] cursor-pointer"
      onSubmit={handleSubmit}
    >
      <div
        onClick={() => setOpenDropdown(!openDropdown)}
        className="flex items-center border-b justify-start pl-[20px] h-[93px] md:h-full basis-1/5"
      >
        <FaBed className="text-golden text-[25px]"></FaBed>
        <div className="ml-[20px]">
          <label className="block font-bold">Room Type</label>
          <span className="text-gray-text">
            <span className="flex items-center">
              {typeState}
              <MdOutlineArrowDropDown
                className="ml-[5px]"
                size={20}
              ></MdOutlineArrowDropDown>
            </span>
          </span>
          {openDropdown && (
            <div className="options cursor-pointer">
              <div
                className="optionItem"
                onClick={() => setTypeState("Standard Room")}
              >
                <span className="optionText">Standard Room</span>
              </div>
              <div
                className="optionItem"
                onClick={() => setTypeState("Twin Room")}
              >
                <span className="optionText">Twin Room</span>
              </div>
              <div
                className="optionItem"
                onClick={() => setTypeState("Deluxe Room")}
              >
                <span className="optionText">Deluxe Room</span>
              </div>
              <div
                className="optionItem"
                onClick={() => setTypeState("Suite Room")}
              >
                <span className="optionText">Suite Room</span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        onClick={() => setOpenDate(!openDate)}
        className="flex items-center justify-start border-b md:border-l pl-[20px] border-inherit h-[93px] md:h-full basis-1/5"
      >
        <AiTwotoneCalendar className="text-golden text-[18px]"></AiTwotoneCalendar>
        <div className="ml-[20px]">
          <label className="block font-bold">Check-In</label>
          <span className="text-gray-text">{`${format(
            dateState[0].startDate,
            "dd/MM/yyyy"
          )} `}</span>
        </div>
      </div>
      <div
        onClick={() => setOpenDate(!openDate)}
        className="flex items-center justify-start border-b border-l pl-[20px] border-inherit h-[93px] md:h-full basis-1/5"
      >
        <AiTwotoneCalendar className="text-golden text-[18px]"></AiTwotoneCalendar>
        <div className="ml-[20px]">
          <label className="block font-bold">Check-Out</label>
          <span className="text-gray-text">{`${format(
            dateState[0].endDate,
            "dd/MM/yyyy"
          )}`}</span>
        </div>
      </div>
      <div
        onClick={() => setOpenOptions(!openOptions)}
        className="flex items-center justify-start  border-l pl-[20px] border-inherit h-[93px] md:h-full basis-1/5 relative"
      >
        <FaUserFriends className="text-golden text-[22px]"></FaUserFriends>
        <div className="ml-[20px]">
          <label className="block font-bold">Guests</label>
          <span className="text-gray-text">{`${options.adult} adult · ${options.room} room`}</span>
          {openOptions && (
            <div className="options">
              <div className="optionItem">
                <span className="optionText">Adult</span>
                <div className="optionCounter">
                  <button
                    disabled={options.adult <= 1}
                    className="optionCounterButton"
                    onClick={() => handleOption("adult", "d")}
                  >
                    -
                  </button>
                  <span className="optionCounterNumber">{options.adult}</span>
                  <button
                    className="optionCounterButton"
                    onClick={() => handleOption("adult", "i")}
                  >
                    +
                  </button>
                </div>
              </div>
              <div className="optionItem">
                <span className="optionText">Room</span>
                <div className="optionCounter">
                  <button
                    disabled={options.room <= 1}
                    className="optionCounterButton"
                    onClick={() => handleOption("room", "d")}
                  >
                    -
                  </button>
                  <span className="optionCounterNumber">{options.room}</span>
                  <button
                    className="optionCounterButton"
                    onClick={() => handleOption("room", "i")}
                  >
                    +
                  </button>
                </div>
              </div>
              <div className="my-[20px]  w-full">
                <button
                  id="booknow-btn"
                  className="bg-golden md:flex md:items-center md:justify-center text-white font-bold w-full  md:basis-1/5 h-[30px]"
                  onClick={() => {
                    setOpenOptions(false);
                  }}
                >
                  Done
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <button
        className="bg-golden md:flex md:items-center md:justify-center text-white font-bold w-full md:basis-1/5 h-[93px] md:h-full"
        type="submit"
      >
        <p className="">Book Now</p>
      </button>
      {openDate && (
        <div className="absolute z-[1000] top-[45px] left-1/2 transform -translate-x-1/2  shadow-lg z-[1]">
          <DateRangePicker
            onChange={(item) => setDateState([item.selection])}
            showSelectionPreview={false}
            moveRangeOnFirstSelection={false}
            months={1}
            ranges={dateState}
            direction="horizontal"
            minDate={new Date()}
            className=""
            definedRanges={[]}
            rangeColors={["#b99470"]}
          />
          <button
            className="bg-golden flex items-center justify-center text-white font-bold w-full h-[50px] border-2 border-grey-200"
            onClick={() => {
              setOpenDate(false);
            }}
          >
            Done
          </button>
        </div>
      )}
    </form>
  );
};
